export const kpiMetricBundle = {
  today: { ko: "동 시간 대비", en: "vs. Same Time", es: "vs. misma hora" },
  "7days": { ko: "전주 대비", en: "vs. Last Week", es: "vs. semana pasada" },
  "30days": { ko: "전월 대비", en: "vs. Last Month", es: "vs. mes pasado" }
}

export const kpiMetricCompareBundle = {
  yesterday: {
    ko: "어제",
    en: "Yesterday",
    es: "Ayer"
  },
  currentHour: {
    ko: "최근 1시간",
    en: "Last hour",
    es: "Última hora"
  },
  previousWeek: {
    ko: "전주",
    en: "Previous 7 days",
    es: "7 días anteriores"
  },
  previousMonth: {
    ko: "전월",
    en: "Previous 30 days",
    es: "30 días anteriores"
  }
}
